// https://github.com/microsoft/applicationinsights-react-js/blob/main/sample/applicationinsights-react-sample/src/ApplicationInsightsService.tsx
// https://github.com/microsoft/applicationinsights-react-js/blob/main/sample/applicationinsights-react-sample/src/TestPage.tsx

// https://learn.microsoft.com/nb-no/azure/azure-monitor/app/javascript-framework-extensions?tabs=react

import {ApplicationInsights, ITelemetryItem} from '@microsoft/applicationinsights-web';
//import {ReactPlugin} from '@microsoft/applicationinsights-react-js';

// https://learn.microsoft.com/nb-no/azure/azure-monitor/app/javascript-feature-extensions?tabs=npmpackage
import {ClickAnalyticsPlugin} from '@microsoft/applicationinsights-clickanalytics-js';


// NOT NEEDED due to the config setting enableAutoRouteTracking: true
//import { createBrowserHistory } from "history";
//const browserHistory = createBrowserHistory();

// React Plugin configuration. Not used if you are using the Click Analytics plug-in.
//const reactPlugin = new ReactPlugin();

// Click Analytics instance. Add this to the extensions array in the configuration object.
const clickPluginInstance = new ClickAnalyticsPlugin();
// Click Analytics configuration. Not used if you are using the React plug-in.
const clickPluginConfig = {
  autoCapture: true
};

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING,
    //extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    //enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    extensionConfig: {
      // If you are using the React plugin, you also need to provide the history object to the plugin.
      // *** This is not needed if you are using the Click Analytics plug-in. ***
      //    [reactPlugin.identifier]: { history: browserHistory }
      // *** Add the Click Analytics plug-in. ***
      [clickPluginInstance.identifier]: clickPluginConfig
    }
  }
});

/*
appInsights.addTelemetryInitializer((env:ITelemetryItem) => {
    env.tags = env.tags || {};
    env.tags["ai.cloud.role"] = "<app-role-frontend>";
    //custom props
    env.data = env.data || {};
    env.data["ms-appName"] = "<frontend-name>";
    env.data["ms-user"] = "<frontend-auth-user>";
    env.data["ms-userid"] = "<frontend-auth-userid>";
});
*/


//export { reactPlugin, appInsights };
appInsights.loadAppInsights();
appInsights.trackPageView();
export { appInsights, clickPluginInstance };